import { Typography } from '@sanlam-glacier/app-common/components';
import SummaryCard from '../../molecules/summary-card/SummaryCard';
import styles from './tracking.module.scss';
import { CaseTrackingTable } from '../../organisms/case-tracking-table/CaseTrackingTable';
import { SummaryCardType } from 'modules/case-tracking/types/case-tracking.enums';
import { BreakpointProvider } from 'providers/breakpoint/BreakpointProvider';
import { useQuery } from '@tanstack/react-query';
import { Status } from 'modules/case-tracking/types/filtering/filtering.enums';
import { mockCaseData } from 'stores/case-tracking-mock-data';

// Todo - Remove this mock function when integrating with real API
const fetchAllInstructions = async () => {
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const allCases = mockCaseData;

  if (!allCases) {
    throw new Error(`No instructions found`);
  }
  return allCases;
};

const Tracking = () => {
  const {
    data: instructions,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['allInstructions'],
    queryFn: () => fetchAllInstructions()
  });

  const progressCount = () => {
    const inProgress = instructions?.filter(
      (instruction) => instruction.status !== Status.completed
    );
    if (!inProgress) {
      return 0;
    }
    return inProgress.length;
  };

  const outstandingCount = () => {
    const outstanding = instructions?.filter(
      (instruction) => instruction.status === Status.requirementRequested
    );
    if (!outstanding) {
      return 0;
    }
    return outstanding.length;
  };

  const completedCount = () => {
    const now = new Date();
    const thirtyDayLimit = new Date();
    thirtyDayLimit.setDate(now.getDate() - 30);

    const completed = instructions?.filter(
      (instruction) =>
        instruction.status === Status.completed && instruction.lastModified >= thirtyDayLimit
    );
    if (!completed) {
      return 0;
    }
    return completed.length;
  };

  if (isLoading) return <div>Loading cases...</div>;
  if (isError) return <div>Error loading case: {(error as Error).message}</div>;

  return (
    <BreakpointProvider>
      <div className={styles.container}>
        <Typography
          className={styles.title}
          variant={Typography.VARIANT.H2}
          weight={Typography.WEIGHT.BOLD}
        >
          Case Tracking
        </Typography>
        <div className={styles.summaryCardsContainer}>
          <SummaryCard caseCount={progressCount()} cardType={SummaryCardType.progress} />
          <SummaryCard caseCount={outstandingCount()} cardType={SummaryCardType.outstanding} />
          <SummaryCard caseCount={completedCount()} cardType={SummaryCardType.completed} />
        </div>
        <CaseTrackingTable />
      </div>
    </BreakpointProvider>
  );
};

export default Tracking;
